import React from "react";
import { Form } from "@components";

type Props = {
  checked: boolean | undefined;
  name: "host" | "type";
  onChange: (name: "host" | "type", value: string, checked: boolean) => void;
  option: string;
};

export const Filter: React.FC<Props> = ({
  checked,
  name,
  onChange,
  option,
}) => {
  return (
    <Form.Checkbox
      name={option}
      size={12}
      label={option}
      value={checked}
      onChange={(option, checked) => {
        onChange(name, option, checked);
      }}
    />
  );
};
